import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Next_logo.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center min-h-screen text-center px-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      class: "mb-5"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-bold text-xl mb-3" }, "La gestione dei progetti si è spostata sul nuovo Next-Yu", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-3" }, [
      _createTextVNode(" Questa sezione del vecchio gestionale è stata dismessa e non è più in uso."),
      _createElementVNode("br"),
      _createTextVNode(" Progetti e sottoprogetti si consultano e si gestiscono esclusivamente sul nuovo Next-Yu. ")
    ], -1)),
    _cache[4] || (_cache[4] = _createElementVNode("a", {
      href: "https://nextyu-qaprod.nextgroup.eu/progetti/sottoprogetti/",
      target: "_blank",
      rel: "noopener",
      class: "bg-next-orange text-white font-bold px-4 py-2 mb-3"
    }, "Vai ai progetti su Next-Yu", -1)),
    _createVNode(_component_router_link, {
      to: {name:'Home'},
      class: "text-next-orange underline text-sm"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Torna alla home")
      ])),
      _: 1
    })
  ]))
}